import 'css-chunksrc/client/scenes/costProfileEdition/form/costInput/styles.scss';export default {
  "costInput": "_costInput_2um4s_1",
  "input": "_input_2um4s_6",
  "placeholder": "_placeholder_2um4s_10"
};